import React from 'react';
import Select from '@/components/ui/Select';
import Icon from '@/components/AppIcon';

const CareerGoalsStep = ({ formData, onChange, errors,countries }) => {

const industryOptions = [
{ value: 'technology', label: 'Technology & Software' },
{ value: 'information_services', label: 'Information Services & Data' },
{ value: 'telecommunications', label: 'Telecommunications' },

{ value: 'finance', label: 'Finance & Banking' },
{ value: 'investment', label: 'Investment & Asset Management' },
{ value: 'insurance', label: 'Insurance' },
{ value: 'fintech', label: 'FinTech' },

{ value: 'healthcare', label: 'Healthcare & Medical' },
{ value: 'pharmaceutical', label: 'Pharmaceuticals & Biotechnology' },
{ value: 'medical_devices', label: 'Medical Devices' },

{ value: 'education', label: 'Education & Training' },
{ value: 'research', label: 'Research & Academia' },
{ value: 'edtech', label: 'Education Technology (EdTech)' },

{ value: 'marketing', label: 'Marketing & Advertising' },
{ value: 'public_relations', label: 'Public Relations & Communications' },
{ value: 'media', label: 'Media & Entertainment' },
{ value: 'publishing', label: 'Publishing & Journalism' },

{ value: 'sales', label: 'Sales & Business Development' },

{ value: 'engineering', label: 'Engineering' },
{ value: 'manufacturing', label: 'Manufacturing & Production' },
{ value: 'automotive', label: 'Automotive' },
{ value: 'aerospace', label: 'Aerospace & Aviation' },

{ value: 'construction', label: 'Construction & Infrastructure' },
{ value: 'real_estate', label: 'Real Estate & Property Management' },
{ value: 'architecture', label: 'Architecture & Planning' },

{ value: 'consulting', label: 'Consulting & Strategy' },

{ value: 'retail', label: 'Retail' },
{ value: 'ecommerce', label: 'E-commerce' },
{ value: 'wholesale', label: 'Wholesale & Distribution' },

{ value: 'hospitality', label: 'Hospitality & Tourism' },
{ value: 'food_beverage', label: 'Food & Beverage' },
{ value: 'restaurants', label: 'Restaurants & Catering' },

{ value: 'logistics', label: 'Logistics & Supply Chain' },
{ value: 'transportation', label: 'Transportation & Mobility' },
{ value: 'shipping', label: 'Shipping & Maritime' },

{ value: 'energy', label: 'Energy & Utilities' },
{ value: 'renewable_energy', label: 'Renewable Energy' },
{ value: 'oil_gas', label: 'Oil & Gas' },

{ value: 'agriculture', label: 'Agriculture & Agribusiness' },
{ value: 'mining', label: 'Mining & Metals' },

{ value: 'government', label: 'Government & Public Administration' },
{ value: 'nonprofit', label: 'Nonprofit & NGOs' },
{ value: 'international_orgs', label: 'International Organizations' },

{ value: 'legal', label: 'Legal Services' },
{ value: 'human_resources', label: 'Human Resources & Recruitment' },

{ value: 'security', label: 'Security & Investigations' },
{ value: 'defense', label: 'Defense & Military' },

{ value: 'environment', label: 'Environmental Services' },
{ value: 'sustainability', label: 'Sustainability & Climate' },

{ value: 'sports', label: 'Sports & Recreation' },
{ value: 'fashion', label: 'Fashion & Apparel' },
{ value: 'beauty', label: 'Beauty & Cosmetics' },

{ value: 'creative', label: 'Creative & Design' },
{ value: 'gaming', label: 'Gaming & Esports' }
];

const targetCountryOptions = countries.map(country => ({
  value: country.name,
  label: country.name
}));

const workPreferenceOptions = [
{ value: 'remote', label: 'Remote Only' },
{ value: 'onsite', label: 'On-site Only' },
{ value: 'hybrid', label: 'Hybrid (Remote + On-site)' },
{ value: 'flexible', label: 'Flexible / No Preference' }
];

const salaryRanges = [
{ min: 0, max: 500, label: '$100 - $500' },
{ min: 500, max: 1000, label: '$500 - $1,000' },
{ min: 1000, max: 5000, label: '$1,000 - $5,000' },
{ min: 5000, max: 10000, label: '$5,000 - $10,000' },
{ min: 10000, max: 50000, label: '$10,000 - $50,000' },
{ min: 50000, max: 100000, label: '$50,000 - $100,000' },
{ min: 100000, max: 999999, label: '$100,000+' },
];

const languagesOptions = [
{ value: 'english', label: 'English' },
{ value: 'mandarin', label: 'Mandarin Chinese' },
{ value: 'spanish', label: 'Spanish' },
{ value: 'hindi', label: 'Hindi' },
{ value: 'arabic', label: 'Arabic' },
{ value: 'french', label: 'French' },
{ value: 'portuguese', label: 'Portuguese' },
{ value: 'bengali', label: 'Bengali' },
{ value: 'russian', label: 'Russian' },
{ value: 'urdu', label: 'Urdu' },
{ value: 'indonesian', label: 'Indonesian (Bahasa Indonesia)' },
{ value: 'german', label: 'German' },
{ value: 'japanese', label: 'Japanese' },
{ value: 'turkish', label: 'Turkish' },
{ value: 'korean', label: 'Korean' },
{ value: 'italian', label: 'Italian' },
{ value: 'thai', label: 'Thai' },
{ value: 'vietnamese', label: 'Vietnamese' },
{ value: 'persian', label: 'Persian (Farsi)' },
{ value: 'dutch', label: 'Dutch' },
{ value: 'polish', label: 'Polish' },
{ value: 'ukrainian', label: 'Ukrainian' },
{ value: 'malay', label: 'Malay' },
{ value: 'tagalog', label: 'Tagalog (Filipino)' },
{ value: 'greek', label: 'Greek' },
{ value: 'hebrew', label: 'Hebrew' },
{ value: 'czech', label: 'Czech' },
{ value: 'romanian', label: 'Romanian' },
{ value: 'hungarian', label: 'Hungarian' },
// African languages
{ value: 'kinyarwanda', label: 'Kinyarwanda' },
{ value: 'kirundi', label: 'Kirundi' },
{ value: 'swahili', label: 'Swahili' },
{ value: 'lingala', label: 'Lingala' },
{ value: 'kikongo', label: 'Kikongo' },
{ value: 'tshiluba', label: 'Tshiluba' },
{ value: 'luganda', label: 'Luganda' },
{ value: 'luo', label: 'Luo' },
{ value: 'amharic', label: 'Amharic' },
{ value: 'tigrinya', label: 'Tigrinya' },
{ value: 'oromo', label: 'Oromo' },
{ value: 'somali', label: 'Somali' },
{ value: 'afar', label: 'Afar' },

// West Africa
{ value: 'hausa', label: 'Hausa' },
{ value: 'yoruba', label: 'Yoruba' },
{ value: 'igbo', label: 'Igbo' },
{ value: 'fulani', label: 'Fulani (Fula/Fulfulde)' },
{ value: 'wolof', label: 'Wolof' },
{ value: 'bambara', label: 'Bambara' },
{ value: 'akan', label: 'Akan (Twi)' },
{ value: 'ewe', label: 'Ewe' },
{ value: 'ga', label: 'Ga' },

// Southern Africa
{ value: 'zulu', label: 'Zulu' },
{ value: 'xhosa', label: 'Xhosa' },
{ value: 'afrikaans', label: 'Afrikaans' },
{ value: 'tswana', label: 'Tswana' },
{ value: 'sesotho', label: 'Sesotho' },
{ value: 'northern_sotho', label: 'Northern Sotho (Sepedi)' },
{ value: 'swati', label: 'Swati (Siswati)' },
{ value: 'ndebele', label: 'Ndebele' },
{ value: 'shona', label: 'Shona' },
{ value: 'chewa', label: 'Chewa (Chichewa/Nyanja)' },
{ value: 'tsonga', label: 'Tsonga' }
];

const handleInputChange = (field, value) => {
onChange({ ...formData, [field]: value });
};

const handleSalaryRangeSelect = (range) => {
onChange({ 
...formData, 
salaryMin: range?.min,
salaryMax: range?.max
});
};

const selectedSalaryRange = salaryRanges?.find(
range => range?.min === formData?.salaryMin && range?.max === formData?.salaryMax
);

return (
<div className="space-y-6">
<div className="step-form-section">
<div className="mb-4">
<h2 className="step-form-section-title">Career Goals & Preferences</h2>
<p className="step-description">Define your career preferences</p>
</div>

<Select
label="Target Industry"
placeholder="Select your preferred industry"
description="Choose the industry you want to work in"
options={industryOptions}
value={formData?.industry || ''}
onChange={(value) => handleInputChange('industry', value)}
error={errors?.industry}
required
searchable
/>

<div className="mt-6">
<label className="block text-sm font-medium text-foreground mb-3">
Expected Salary Range <span className="text-xs">(Be realistic)</span> <span className="text-error">*</span>
</label>
<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
{salaryRanges?.map((range) => {
const isSelected = selectedSalaryRange?.min === range?.min && selectedSalaryRange?.max === range?.max;
return (
<button
key={`${range?.min}-${range?.max}`}
type="button"
onClick={() => handleSalaryRangeSelect(range)}
className={`tag-option ${isSelected ? 'selected' : ''}`}
>
{range?.label}
</button>
);
})}
</div>
{errors?.salary && (
<p className="text-sm text-error mt-2">{errors?.salary}</p>
)}
</div>

<Select
label="Target Country/Region"
placeholder="Select target location"
description="Where would you like to work?"
options={targetCountryOptions}
value={formData?.targetCountry || ''}
onChange={(value) => handleInputChange('targetCountry', value)}
error={errors?.targetCountry}
required
searchable
multiple
className="mt-6"
/>

<Select
label="Work Preference"
placeholder="Select work arrangement"
description="Choose your preferred work setup"
options={workPreferenceOptions}
value={formData?.workPreference || ''}
onChange={(value) => handleInputChange('workPreference', value)}
error={errors?.workPreference}
required
className="mt-6"
/>


<Select
label="Fluent Languages"
placeholder="Select languages you are fluent at"
description="Choose languages you are fluent at"
options={languagesOptions}
value={formData?.fluentLanguages || ''}
onChange={(value) => handleInputChange('fluentLanguages', value)}
error={errors?.fluentLanguages}
required
searchable
multiple
className="mt-6"
/>




<div className="mt-6 p-4 bg-blue-50 dark:bg-blue-950/20 rounded-lg border border-blue-200 dark:border-blue-800">
<div className="flex items-start gap-3">
<Icon name="Lightbulb" size={20} className="text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
<div className="text-sm text-blue-900 dark:text-blue-100">
<p className="font-medium mb-1">Pro Tip:</p>
<p className="text-blue-800 dark:text-blue-200">
Being flexible with location and work arrangement can increase your job opportunities by up to 3x.
</p>
</div>
</div>
</div>
</div>
</div>
);
};

export default CareerGoalsStep;